<template>
  <div class="flex-1 z-0 flex flex-col bg-gray-100">
    <main class="flex-1 z-0">
      <div
        class="mx-auto p-4"
        :class="[
          { container: type == 'center', 'w-full': type == 'full' },
          compClass
        ]"
      >
        <slot></slot>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "center"
    },
    compClass: {
      type: String,
      default: ""
    }
  }
};
</script>
